module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-426373a0905665cb4a6723ed5d777370.png";